// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3dCGG","content":"styles_content__3htqH","selectAll":"styles_selectAll__3LImh"};